<template>
    <!-- Inicio modal de Orçamentos e Propostas  -->  
    <div id="modalOrcamentoProposta" class="w3-modal" v-if="visivel" @click="cancelarPdf()" style="display: block">
      <div class="w3-modal-content w3-animate-zoom" @click.stop>
        <header class="w3-container">
          <span @click="cancelarPdf()" class="w3-button w3-display-topright">&times;</span>
          <h5 class="texto-vermelho"><b><i class="fa fa-print"></i> Opções de Impressão da Proposta</b></h5>
        </header>
        <div class="w3-row-padding w3-margin-bottom">
          <div class="w3-row">
            <div class="w3-half w3-row-padding">
              <div class="w3-col s12 m12 l6 w3-margin-top">
                <strong>Data de validade</strong>
                <input class="w3-input w3-border" v-model="data_validade" type="date" maxlength="10" placeholder="Dia/Mês/Ano"  id="data_validade" :disabled="!alterar_data_validade_orcamentos" onkeyup="FormataDataDiaMesAno(this,'##/##/####',event)"/>
              </div>
              <div class="w3-col s12 m12 l6 w3-margin-top">
                <strong>Data de emissão</strong>
                <input class="w3-input w3-border" :value="fData(data_de_emissao)" type="text" disabled placeholder="Dia/Mês/Ano"  id="data_emissao"/>
              </div>
            </div>
            <div class="w3-half w3-row-padding">
              <div class="w3-col s12 m12 l6 w3-margin-top">
                <strong>Prazo de entrega</strong>
                <vue-numeric style="min-width: 100px" id="prazo_de_entrega" class="w3-input w3-border" v-bind:precision="0" 
                @input="eventPrazoEntrega" v-model="prazo_entrega_input"></vue-numeric>
              </div>
              <div class="w3-col s12 m12 l6 w3-margin-top">
                <strong>Prazo considerado</strong>
                <input class="w3-input w3-border" disabled v-model="prazo_considerado" min="3" max="365" type="number"/>
              </div>
            </div>
            <div class="w3-row-padding">
              <div class="w3-col s12 m12 l12 w3-margin-top">
                <strong>A/C</strong>
                <input class="w3-input w3-border" v-model="aos_cumprimentos" type="text"/>
              </div>
            </div>
            <div class="w3-row-padding">
              <div class="w3-col s12 m12 l12 w3-margin-top">
                <strong>Observação da proposta</strong>
                <textarea v-model="observacao_proposta" class="w3-border texto-preto" style="width:100%; resize: none; height: 150px"></textarea>
              </div>
            </div>
            <div class="w3-row-padding">
              <div class="w3-margin-top w3-col s12 m12"
                :class="{'l10' : parseInt(tamanho_nome_prod_proposta_orc) == 0,  'l8': parseInt(tamanho_nome_prod_proposta_orc) > 0 }">
                <strong>Tipo de desconto unitário</strong>
                <select class="w3-input w3-border" @change="verificarDescontoUnitario()" v-model="tipo_desconto_unitario" name="tipo_proposta" id="tipo_proposta"
                :disabled="!imprimir_valor_unitario_itens_orcamentos || desabilitar_tipo_desconto_unitario" >
                  <!-- when disabled seed -1 -->
                  <option value="-1" v-show="false">Não mostrar o desconto unitário</option> 
                  <option value="0">Não mostrar o desconto unitário</option>
                  <option value="1">Mostrar o desconto unitário do fechamento</option>
                  <option value="2">Mostrar o desconto unitário do fechamento e o do F5</option>
                  <option value="3">Mostrar o desconto unitário do fechamento, do F5 e percentual de desconto geral</option>
                </select>
              </div>
              <div class="w3-col s12 m6 l2 w3-margin-top" v-if="parseInt(tamanho_nome_prod_proposta_orc) > 0">
                <strong>Tam. nome prod.</strong>
                <input id="tam_nome_prod" type="number" :disabled="!alterar_tam_produto_prop_orc" @blur="eventTamanhoNomePdf()" class="w3-input w3-border" min="0" max="99" v-model="tam_nome_prod" maxlength = "2"
                  oninput="validity.valid||(value='');" />
              </div>
              <div class="w3-col s12 m6 l2 w3-margin-top div-btn-filtro">
                <br>
                <button 
                  class="w3-col w3-button w3-theme" 
                  @click="abrirFiltrosOrcamentoProposta = !abrirFiltrosOrcamentoProposta">
                  <i class="fa fa-filter"/> Filtros
                </button>
              </div>
            </div>
          </div>
          <div class="w3-row-padding w3-padding-bottom filtros" v-if="abrirFiltrosOrcamentoProposta">
            <div class="w3-col">
              <div class="w3-col s12 m6 l4 w3-margin-top">
                <input class="w3-check" :disabled="!imprimir_valor_unitario_itens_orcamentos" v-model="imprimir_preco_unitario" value="imprimir_preco_unitario" type="checkbox" @change="verificarPrecoUnitario()">
                <strong :class="{disable: !imprimir_valor_unitario_itens_orcamentos, enable: imprimir_valor_unitario_itens_orcamentos}"> Imprimir preço unitário</strong>
              </div>
              <div class="w3-col s12 s6 l4 w3-margin-top">
                <input class="w3-check" v-model="imprimir_preco_liquido" value="imprimir_preco_liquido" type="checkbox" :disabled="desabilitar_preco_liquido || !imprimir_valor_unitario_itens_orcamentos">
                <strong :class="{disable: desabilitar_preco_liquido || !imprimir_valor_unitario_itens_orcamentos, enable: !desabilitar_preco_liquido && imprimir_valor_unitario_itens_orcamentos}"> Imprimir preço líquido</strong>
              </div>
              <div class="w3-col s12 m6 l4 w3-margin-top">
                <input class="w3-check" v-model="imprimir_peso" value="imprimir_peso" type="checkbox">
                <strong> Imprimir peso</strong>
              </div>
              <div class="w3-col s12 m6 l4 w3-margin-top" v-if="emitir_marca_imp_orc_graf">
                <input class="w3-check" v-model="imprimir_marca" value="imprimir_marca" type="checkbox">
                <strong  :class="{disable: !emitir_marca_imp_orc_graf, enable: emitir_marca_imp_orc_graf}"> Imprimir marca</strong>
              </div>
              <div class="w3-col s12 m6 l4 w3-margin-top">
                <input class="w3-check" v-model="imprimir_st_ipi_unitario" value="imprimir_st_ipi_unitario" type="checkbox">
                <strong>Imprimir ST/IPI unitário</strong>
              </div>
              <div class="w3-col s12 m6 l4 w3-margin-top">
                <input class="w3-check" v-model="imprimir_icms" value="imprimir_icms" type="checkbox">
                <strong> Imprimir% ICMS</strong>
              </div>
              <div class="w3-col s12 m6 l4 w3-margin-top">
                <input class="w3-check" v-model="imprimir_ncm" value="imprimir_ncm" type="checkbox">
                <strong> Imprimir NCM</strong>
              </div>
              <div class="w3-col s12 m6 l4 w3-margin-top">
                <input class="w3-check" v-model="imprimir_foto_produto" value="imprimir_foto_produto" type="checkbox">
                <strong>Imprimir fotos de produtos</strong>
              </div>
              <div class="w3-col s12 m6 l4 w3-margin-top">
                <input class="w3-check" v-model="imprimir_caracteristicas" value="imprimir_caracteristicas" type="checkbox">
                <strong>Imprimir características</strong>
              </div>
              <div class="w3-col s12 m6 l4 w3-margin-top">
                <input class="w3-check" v-model="imprimir_lista_ordem_alfabetica" value="imprimir_lista_ordem_alfabetica" type="checkbox">
                <strong>Imprimir lista por ordem alfabética</strong>
              </div>        
              <div class="w3-col s12 m6 l4 w3-margin-top">
                <input class="w3-check" v-model="imprimir_disponibilidade" value="imprimir_disponibilidade" type="checkbox">
                <strong>Imprimir disponibilidade</strong>
              </div>                  
              <div class="w3-col s12 m6 l4 w3-margin-top">
                <input class="w3-check" disabled type="checkbox">
                <strong class="disable">Imprimir corte</strong>
              </div>         
              <div class="w3-col s12 m6 l4 w3-margin-top">
                <input class="w3-check" disabled type="checkbox">
                <strong class="disable">Imprimir profissional comissionado do orçamento</strong>
              </div>
            </div>
          </div>
        </div>
        <div class="w3-container">
          <div clas="w3-row-padding" style="padding: 0 8px;">
            <button 
              :disabled="processando"
              @click="gerarPropostaOrcamento()"
              class="w3-button w3-theme botao-100" 
              style="margin-top: 10px; margin-bottom:10px">
              <i class="fas fa-check-circle"/> Ok
            </button>

            <button 
              :disabled="processando"
              @click="cancelarPdf()"
              class="w3-button w3-text-theme w3-border w3-right" 
              style="margin-top: 10px; margin-bottom:10px">
              <i class="fas fa-times-circle"/> Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
  import moment from 'moment'
  import VueNumeric from 'vue-numeric'
  import formatarValorMixin from '@/mixins/formatarValorMixin'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  import ROrcamentoBuscarPropostaOrcamento from '@/components/Rest/ROrcamento/ROrcamentoBuscarPropostaOrcamento.js'
  import ROrcamentoBuscarStatusPropostaOrcamento from '@/components/Rest/ROrcamento/ROrcamentoBuscarStatusPropostaOrcamento.js'
  import ROrcamentoBuscarDadosIniciaisPropostasOrcamentos from '@/components/Rest/ROrcamento/ROrcamentoBuscarDadosIniciaisPropostasOrcamentos.js'

  export default {
    name: 'ModalImpressaoPropostaOrcamento',

    mixins:[formatarValorMixin],

    components: {
      VueNumeric
    },

    props:{
      recarregarTela: {
        required: true,
        type: String,
        default: 'N'
      },

      parEmpGerarBloqPropostaOrcamento: {
        required: true,
        type: String,
        default: 'S'
      },

      telaOrigemImpressaoProposta: {
        required: true,
        type: String,
        default: ''
      },

      recarregarComponente: {
        required: false,
        type: Function,
        default: function () {
          return {}
        }
      },
    },
    data() {
      return {
        api: process.env.API,
        visivel: false,
        processando: false,

        // Opções 
        tam_nome_prod: 0,
        data_validade: '',
        data_de_emissao: '',
        prazo_entrega: '',
        prazo_entrega_rede: '',
        prazo_entrega_input: '',
        prazo_entrega_orc: '',
        data_minima_rota: '',
        data_minima_entrega: '',
        data_entrega_pedido: '',
        prazo_considerado: 1,
        aos_cumprimentos: '',
        observacao_proposta: '',
        tipo_entrega: '',
        tamanho_nome_prod_proposta_orc: '',
        tipo_desconto_unitario: '',
        desabilitar_tipo_desconto_unitario: false,
        imprimir_valor_unitario_itens_orcamentos: false,
        alterar_tam_produto_prop_orc: false, 
        abrirFiltrosOrcamentoProposta: true,
        imprimir_preco_unitario: false,
        imprimir_preco_liquido: false,
        desabilitar_preco_liquido: false,
        imprimir_peso: false,
        tipo_proposta: 'tpProposta',
        unidade_monetaria: 'REAL',
        emitir_marca_imp_orc_graf: false,
        imprimir_marca: false,
        imprimir_st_ipi_unitario: false,
        imprimir_icms: false,
        imprimir_ncm: false,
        imprimir_corte: false,
        imprimir_produtos_ambiente: false,
        imprimir_foto_produto: false,
        imprimir_caracteristicas: false,
        imprimir_lista_ordem_alfabetica: false,
        imprimir_disponibilidade: false,
        alterar_data_validade_orcamentos: false,
        imprimir_profissional_comissionado: false,
      }
    },
    methods: {
      async abrir(orcamento_id){
        this.orcamento_id = Biblioteca.valorInt(orcamento_id);
        
        let retorno = await this.imprimirProposta();

        if (retorno){
          this.visivel = true;
        }

        return retorno;
      },

      async cancelarPdf() {
        this.visivel = false;
        
        if (this.recarregarTela == 'S'){
          this.recarregarComponente();
        }
      },

      fData(date) {
        if (!date){
          return "";
        }

        return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
      },

      eventTamanhoNomePdf() {
        this.tam_nome_prod = this.tam_nome_prod.replace(/^0+/, '')
       
        if (Biblioteca.valorInt(this.tam_nome_prod) > 50) {
          this.tam_nome_prod = '';
        }  
      },

      eventPrazoEntrega() {
        this.prazo_entrega_input = parseInt(this.prazo_entrega_input)

        if (this.prazo_entrega_input > 365) {
          this.prazo_entrega_input = this.prazo_considerado = 365;
          return;
        } else if (this.prazo_entrega_input > this.prazo_entrega) {
          this.prazo_considerado = this.prazo_entrega_input;
        } else {
          this.prazo_considerado = this.prazo_entrega;
        } 
      },

      verificarDescontoUnitario() {
        !this.abrirFiltrosOrcamentoProposta ? this.abrirFiltrosOrcamentoProposta = true : null;

        switch(this.tipo_desconto_unitario) {
          case '0': case '1':
            this.desabilitar_preco_liquido = false;
            break;
          case '2':
            this.desabilitar_preco_liquido = true;
            this.imprimir_preco_liquido = true;
            break;
          case '3':
            this.desabilitar_preco_liquido = true;
            this.imprimir_preco_liquido = false;
            break;
        }
      },

      verificarPrecoUnitario() {
        if (!this.imprimir_preco_unitario) {
          this.tipo_desconto_unitario = '-1';
          this.desabilitar_tipo_desconto_unitario = true;
          this.desabilitar_preco_liquido = false;
        } else {
          this.tipo_desconto_unitario = '0'
          this.desabilitar_tipo_desconto_unitario = false;
          this.desabilitar_preco_liquido = false;
        }
      },

      async gerarPropostaOrcamento() {
        try {
          let formato_data = 'DD-MM-YYYY';
          let data_valida = moment(moment(this.data_validade).format(formato_data), formato_data, true).isValid();

          if (!data_valida) {
            Biblioteca.exclamar('Data de validade inválida!');
            return;
          }

          if (this.prazo_entrega_input < this.prazo_entrega && this.tipo_entrega != 'ESA') {
            Biblioteca.exclamar(`O prazo de entrega deve ser maior ou igual a ${this.prazo_entrega} dia(s).`);
            document.getElementById('prazo_de_entrega').focus();
            return;
          }

          this.processando = true;

          let parametros = {
            orcamento_id: this.orcamento_id,
            data_validade: moment(this.data_validade, 'YYYY/MM/DD').format('DD/MM/YYYY'),
            data_de_emissao: moment(this.data_de_emissao, 'YYYY/MM/DD').format('DD/MM/YYYY'), 
            prazo_entrega: this.prazo_entrega,
            prazo_considerado: this.prazo_considerado,
            unidade_monetaria: this.unidade_monetaria,
            aos_cumprimentos: this.aos_cumprimentos,
            tipo_proposta: this.tipo_proposta,
            observacao_proposta: this.observacao_proposta,
            tipo_desconto_unitario: this.tipo_desconto_unitario,  
            tam_nome_prod: this.tam_nome_prod,
            imprimir_preco_unitario: this.imprimir_preco_unitario,
            imprimir_preco_liquido: this.imprimir_preco_liquido,
            imprimir_produtos_ambiente: this.imprimir_produtos_ambiente,
            imprimir_peso: this.imprimir_peso,
            imprimir_marca: this.imprimir_marca,
            imprimir_st_ipi_unitario: this.imprimir_st_ipi_unitario,
            imprimir_icms: this.imprimir_icms,
            imprimir_ncm: this.imprimir_ncm,
            imprimir_corte: this.imprimir_corte,
            imprimir_foto_produto: this.imprimir_foto_produto,
            imprimir_caracteristicas: this.imprimir_caracteristicas,
            imprimir_lista_ordem_alfabetica: this.imprimir_lista_ordem_alfabetica,
            imprimir_profissional_comissionado: this.imprimir_profissional_comissionado,
            imprimir_disponibilidade: this.imprimir_disponibilidade
          }

          let retorno = await ROrcamentoBuscarPropostaOrcamento.buscarPropostaOrcamento(this.axios, this.api, parametros);
          this.processando = false;

          if (retorno.houve_erro != 'N'){
            swal(retorno.mensagem);
            return;
          }
          
          if (this.recarregarTela == 'S'){
            await this.recarregarComponente();
          }
        } catch (error) {
          this.processando = false;
        }
      },

      async buscarDadosIniciaisPropostaOrcamentos() {
        try {

          let parametros = {
            orcamento_id: this.orcamento_id
          };

          let retorno = await ROrcamentoBuscarDadosIniciaisPropostasOrcamentos.buscarDadosIniciaisPropostasOrcamentos(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.tipo_desconto_unitario = retorno.dados.tipo_desconto_unitario;
          this.tam_nome_prod = retorno.dados.tamanho_nome_prod_proposta_orc; 
          this.tamanho_nome_prod_proposta_orc = retorno.dados.tamanho_nome_prod_proposta_orc;
          this.observacao_proposta = retorno.dados.observacao;
          this.aos_cumprimentos = retorno.dados.aos_cuidados;
          this.imprimir_valor_unitario_itens_orcamentos = retorno.dados.imprimir_valor_unitario_itens_orcamentos == 'S' ? true : false;
          this.alterar_tam_produto_prop_orc = retorno.dados.alterar_tam_produto_prop_orc == 'S' ? true : false;
          this.alterar_data_validade_orcamentos = retorno.dados.alterar_data_validade_orcamentos == 'S' ? true : false;
          this.imprimir_preco_unitario = retorno.dados.preco_unitario == 'S' ? true : false;
          this.imprimir_preco_liquido = retorno.dados.preco_liquido == 'S' ? true : false;
          this.imprimir_peso = retorno.dados.peso == 'S' ? true : false;
          this.imprimir_st_ipi_unitario = retorno.dados.st_ipi_unitario == 'S' ? true : false;
          this.imprimir_icms = retorno.dados.perc_icms == 'S' ? true : false;
          this.imprimir_ncm = retorno.dados.ncm_unitario == 'S' ? true : false;
          this.imprimir_corte = retorno.dados.corte == 'S' ? true : false;
          this.imprimir_foto_produto = retorno.dados.foto == 'S' ? true : false;
          this.imprimir_caracteristicas = retorno.dados.caracteristicas == 'S' ? true : false;
          this.imprimir_lista_ordem_alfabetica = retorno.dados.ordem_alfabetica == 'S' ? true : false;
          this.imprimir_profissional_comissionado = retorno.dados.profissional_comissionado == 'S' ? true : false;
          this.emitir_marca_imp_orc_graf = this.imprimir_marca  = retorno.dados.emitir_marca_imp_orc_graf == 'S' ? true : false; 
          this.imprimir_marca = retorno.dados.marca == 'S' ? true : false;
          this.imprimir_disponibilidade = retorno.dados.disponibilidade == 'S' ? true : false;
          this.tipo_entrega = retorno.dados.tipo_entrega;
          
          let formato_data_recebida = 'DD-MM-YYYY';
          let formato_data_desejado = 'YYYY-MM-DD';

          this.data_de_emissao = moment().format(formato_data_desejado);

          this.data_validade = moment(retorno.dados.data_validade, formato_data_recebida).format(formato_data_desejado);
          this.data_minima_rota = moment(retorno.dados.data_minima_rota, formato_data_recebida).format(formato_data_desejado);
          this.data_minima_entrega = moment(retorno.dados.data_minima_entrega, formato_data_recebida).format(formato_data_desejado);
          this.data_entrega_pedido = moment(retorno.dados.data_entrega_pedido, formato_data_recebida).format(formato_data_desejado);

          if (moment(this.data_minima_rota).isBefore(this.data_minima_entrega) && moment(this.data_minima_rota).isBefore(this.data_de_emissao))  {
            this.data_minima_rota = this.data_minima_entrega;
          }

          this.prazo_entrega_rede = moment(this.data_minima_rota).diff(moment(this.data_de_emissao), 'days');
          this.prazo_entrega_orc = moment(this.data_entrega_pedido).diff(moment(this.data_de_emissao), 'days');
          
          this.prazo_entrega_input = 0;

          if (this.tipo_entrega == 'ESA') {
            this.prazo_entrega = 0;
          } else {
            if (this.prazo_entrega_orc > this.prazo_entrega_rede) {
              this.prazo_entrega = this.prazo_entrega_orc;
            } else {
              this.prazo_entrega = this.prazo_entrega_rede;
              this.prazo_entrega_input = this.prazo_entrega;
            }
          }

          if (this.prazo_entrega > this.prazo_entrega_input) {
            this.prazo_considerado = this.prazo_entrega;
          } else {
            this.prazo_considerado = this.prazo_entrega_input;
          }     

          if (this.tipo_entrega != 'ESA'){
            this.prazo_entrega_input = this.prazo_entrega; 
          }

          await this.verificarPrecoUnitario();
          await this.verificarDescontoUnitario();

          this.visivel = true;
         } catch (error) {
          Biblioteca.exclamar(error.message);
          this.visivel = false;
          this.processando = false;
        }
      },

      async imprimirProposta(){
        try {

          if (this.parEmpGerarBloqPropostaOrcamento == 'S'){
            let parametros = {
              orcamento_id: this.orcamento_id
            }

            let retorno = await ROrcamentoBuscarStatusPropostaOrcamento.buscarStatusPropostaOrcamento(this.axios, parametros);

            if (retorno.houve_erro == 'S'){
              throw new Error(retorno.mensagem);
            }
            
            if (retorno.dados.houve_erro == 'S'){
              await swal(retorno.dados.mensagem);
              return false;
            } else if (this.telaOrigemImpressaoProposta != 'PESQUISA_ORCAMENTOS'){
              await swal(retorno.dados.mensagem);
            }
          }
          
          await this.buscarDadosIniciaisPropostaOrcamentos();
        } catch (error) {
          this.processando = false;
          return false;
        }

        return true;
      },
    },
  }
</script>
<style scoped>

  #tam_nome_prod:focus { 
    text-align: left;
  }

  #tam_nome_prod { 
    text-align: right;
  }
  

</style>


// WEBPACK FOOTER //
// src/components/Orcamentos/ModalImpressaoPropostaOrcamento.vue